export default __webpack_public_path__ + "static/media/i056jp.f19efffa.webp";